import { _ as _define_property } from "@swc/helpers/_/_define_property";
import React from 'react';
import throttle from 'lodash/throttle';
import ddt from '@wix/da-ddt';
const logger = ddt.createLogger('onscrollbottom');
export var DISTANCE_UNIT = /*#__PURE__*/ function(DISTANCE_UNIT) {
    DISTANCE_UNIT["PX"] = "PX";
    DISTANCE_UNIT["WINDOW_HEIGHT"] = "WINDOW_HEIGHT";
    return DISTANCE_UNIT;
}({});
const DEFAULT_THROTTLE_TIMEOUT = 250;
class OnScrollBottom extends React.Component {
    componentDidMount() {
        window && window.addEventListener('scroll', this.callOnScrolledToBottom);
        if (this.props.checkOnMount) {
            logger.log('checking distance to bottom on mount');
            this.callOnScrolledToBottom();
        }
    }
    componentDidUpdate() {
        if (this.props.checkOnUpdate) {
            logger.log('checking distance to bottom on update');
            this.callOnScrolledToBottom();
        }
    }
    componentWillUnmount() {
        window && window.removeEventListener('scroll', this.callOnScrolledToBottom);
    }
    render() {
        const { children } = this.props;
        if (!children) {
            return null;
        }
        return /*#__PURE__*/ React.cloneElement(children, {
            ref: this.childNodeRef
        });
    }
    getDistanceToBottomWhenShouldTrigger() {
        const { distanceToBottom, distanceUnit } = this.props;
        if (distanceUnit === "PX") {
            return distanceToBottom;
        }
        return distanceToBottom * window.innerHeight;
    }
    getDistanceToBottom() {
        const { children } = this.props;
        if (children) {
            const childNode = this.childNodeRef.current;
            if (!childNode) {
                return 0;
            }
            // this child bottom position is relative to the top of the view port
            const childBottom = childNode.getBoundingClientRect().bottom;
            // we are interestedin the distance from the bottom of the view port to the child bottom
            const distanceToChildBottom = childBottom - window.innerHeight;
            return distanceToChildBottom;
        }
        const distanceToScrollContainerBottom = window.document.body.scrollHeight - window.scrollY - window.innerHeight;
        logger.log('window.document.body.scrollHeight', window.document.body.scrollHeight, 'window.scrollY', window.scrollY, 'window.innerHeight', window.innerHeight, 'distanceToScrollContainerBottom', distanceToScrollContainerBottom);
        return distanceToScrollContainerBottom;
    }
    constructor(...args){
        var _this_props_timeout;
        super(...args), _define_property(this, "prevScrollTop", void 0), _define_property(this, "childNodeRef", /*#__PURE__*/ React.createRef()), _define_property(this, "rememberScrollTop", ()=>{
            this.prevScrollTop = window.scrollY;
        }), _define_property(this, "callOnScrolledToBottom", throttle(()=>requestAnimationFrame(()=>{
                const { onScrolledToBottom } = this.props;
                if (!onScrolledToBottom) {
                    return;
                }
                if (!window.document.body.scrollHeight) {
                    return;
                }
                const distance = this.getDistanceToBottom();
                const threshold = this.getDistanceToBottomWhenShouldTrigger();
                if (distance <= threshold) {
                    logger.log(`distance to bottom ${distance} within ${threshold}`);
                    const scrollDelta = window.scrollY - this.prevScrollTop || 0;
                    onScrolledToBottom(scrollDelta);
                }
                this.rememberScrollTop();
            }), (_this_props_timeout = this.props.timeout) !== null && _this_props_timeout !== void 0 ? _this_props_timeout : DEFAULT_THROTTLE_TIMEOUT));
    }
}
export default OnScrollBottom;

//# sourceMappingURL=OnScrollBottom.js.map